import {SessionTypes} from '@walletconnect/types'
import {WalletPlatform} from '@/enums/WalletPlatform'
import {isMobileBrowser} from '@/helpers/MobileBrowserHelper'

export function buildWalletConnectDeepLink(
  scheme: string,
  walletConnectUri: string
): string {
  const base64 = Buffer.from(walletConnectUri).toString('base64')

  return `${scheme}://uri=${base64}`
}

export function buildWalletConnectQueryDeepLink(
  scheme: string,
  walletConnectUri: string
): string {
  return `${scheme}://wc?uri=${encodeURIComponent(walletConnectUri)}`
}

export const walletConnectSchemeByPlatform: Partial<Record<
  WalletPlatform,
  string
>> = {
  [WalletPlatform.NEON]: 'neon',
  [WalletPlatform.NEOLINE]: 'neoline',
  [WalletPlatform.ONEGATE]: 'onegate',
}

export function openWalletForWalletConnectSession(
  session: SessionTypes.Struct,
  walletPlatform?: WalletPlatform
): void {
  if (typeof window === 'undefined') {
    return
  }

  // WalletConnect supports `metadata.redirect` at runtime, but the `@walletconnect/types`
  // Metadata typing may not include it (depends on version).
  const redirect = ((session as any).peer?.metadata as any)?.redirect as
    | {native?: string; universal?: string}
    | undefined

  const fallbackScheme = walletPlatform
    ? walletConnectSchemeByPlatform[walletPlatform]
    : undefined

  const target =
    redirect?.native ||
    redirect?.universal ||
    (fallbackScheme ? `${fallbackScheme}://` : null)

  if (!target) {
    return
  }

  if (!isMobileBrowser() && !redirect?.native && !redirect?.universal) {
    return
  }

  window.location.href = target
}

export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}
